var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "none",
      stroke: "#1dc071"
    },
    id: "svg11",
    viewBox: "0 0 20 20",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs15"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2,-2)",
    style: {
      strokeWidth: 0
    },
    id: "SVGRepo_bgCarrier"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2,-2)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "SVGRepo_tracerCarrier"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2,-2)",
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "#1dc071",
      strokeWidth: 2
    },
    id: "circle4",
    r: 9,
    cy: 12,
    cx: 12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1dc071",
      stroke: "#1dc071"
    },
    id: "circle6",
    r: 0.5,
    cy: 18,
    cx: 12
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#1dc071",
      strokeWidth: 2
    },
    id: "path8",
    d: "m 12,16 v -1.4189 c 0,-0.9442 0.6042,-1.7825 1.5,-2.0811 v 0 C 14.3958,12.2014 15,11.3631 15,10.4189 V 9.90569 C 15,8.30092 13.6991,7 12.0943,7 H 12 C 10.3431,7 9,8.34315 9,10 v 0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.8164b7069a4e543f84ac58ab138dedd1.svg";
export { ForwardRef as ReactComponent };